import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#2563eb"};
  color: ${(p) => (p.color ? "#0f172a" : "#fff")};
  font-size: 0.95rem;
  font-weight: 600;
  width: 100%;
  border: none;
  border-radius: 8px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    background-color: #1d4ed8;
    transform: translateY(-1px);
  }
`;
